import React from 'react';
import VehiclesByTimeChart from './components/line-chart';
import { Breadcrumb, Card } from 'antd';
import { Link } from 'react-router-dom';
import ShiftBarChart from './components/bar-chart';

import './styles.css';

const Charts = () => {
  return (
    <div className="container-charts">
      <Breadcrumb style={{ padding: '10px' }}>
        <Breadcrumb.Item>
          {/* @ts-expect-error Server Component */}
          <Link to="/">Página Inicial</Link>
        </Breadcrumb.Item>

        <Breadcrumb.Item>Gráficos</Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <VehiclesByTimeChart />
        <ShiftBarChart />
      </Card>
    </div>
  );
};

export default Charts;
